import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffApi';
import * as HeaderActions from '../actions/Header';
import HospitalList from '../components/HospitalList';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HospitalList as any);



// WEBPACK FOOTER //
// ./src/containers/HospitalList.tsx